import React from 'react';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import PureRenderMixin from 'react-addons-pure-render-mixin';

export default React.createClass({
  mixins: [PureRenderMixin],

  render() {
    const {
      // rowIndex,
      item,
      field,
      reverseField,
      onMouseEnter,
      onMouseLeave,
      // onClick
    } = this.props;

    let overriddenNode = null;

    const reverseFieldName = reverseField || `${field}InReverse`;

    //If the field is in reverse it should also be overridden, even if the
    //'field' value is falsey (for example a duration value can be 0, and that's perfectly valid)
    if (item.get(field) || item.get(reverseFieldName)) {
      const iconName = item.get(reverseFieldName)
        ? 'flag-arrow-bidirectional'
        : 'flag-arrow-down';

      overriddenNode = (
        <span
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          style={{ position: 'relative' }}
          onClick={this._handleClick}
        >
          <Icon
            title="Timers Flag"
            className="cs-timers-flag"
            name={iconName}
            ours
          />
        </span>
      );
    }

    return overriddenNode;
  },

  _handleClick(e) {
    e.stopPropagation();

    this.props.onClick();
  },
});
